import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=63830c37&"
import script from "./EditModule.vue?vue&type=script&lang=js&"
export * from "./EditModule.vue?vue&type=script&lang=js&"
import style0 from "./EditModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports